const ProgressBar = ({ macros: data, limit }) => {
    // ORDER OF MACROS TO DISPLAY
    const order = ['carbs', 'protein', 'fat'];

    // LABELS
    const titles = {
        carbs: 'Kolhydrater',
        protein: 'Protein',
        fat: 'Fett',
        alcohol: 'Alkohol',
        kcal: 'EnergiKcal'
    };

    // FILTER ONLY EXPECTED MACROS
    const macros = Object.fromEntries(
        Object.entries(data ?? {}).filter(([key]) => order.includes(key))
    );

    return (
        <div className="progress-energy">
            <ul>
                {order.map((key) => {
                    if (!(key in macros)) return null;

                    // NORMALIZE VALUES
                    const value = Number(macros[key]) || 0;
                    const max = Number(limit?.[key]) || 0;

                    return (
                        <li key={key}>
                            <label htmlFor={`progress-energy-${key}`}>
                                {titles[key] ?? key}
                            </label>

                            <div className="progress-container">
                                <progress
                                    id={`progress-energy-${key}`}
                                    value={value}
                                    max={max || 1} // avoid invalid progress max=0
                                />

                                <span className="progress-text">
                                    {`${value}/${max} g`}
                                </span>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default ProgressBar;
